<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw--mt-1.5"
        >
          <ban-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Disconnect Stripe</h3>
          <div class="tw-mt-2 tw-font-thin tw-text-gray-600">
            <p>Disconnecting Predictile from the Stripe account prevents Predictile from monitoring actions or executing commands in {{ business.name }}'s Stripe account.</p>
            <p class="tw-mt-2">This action is permanent and cannot be undone.</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="disconnect" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Disconnect</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { BanIcon } from "@/assets/svgs";
import EventBus from "@/utils/global-events.js";

export default {
  components: {
    BanIcon,
  },
  props: {
    business: Object,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async disconnect() {
      try {
        this.isLoading = true;
        await this.$axios.put(`/admin/businesses/${this.business.businessId}/disconnect`);
        this.hide();
        this.$emit("disconnected");
        EventBus.$emit("GLOBAL_NOTIFY", { title: "Account Disconnected", message: "This Stripe account was disconnected from Predictile." });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
